/* pg-verified */
(function(){
  if (window.pgVerified) return; window.pgVerified = 1;

  /* djb2: same review, same answer, every load */
  function hash(s){
    var h = 5381;
    for (var i = 0; i < s.length; i++) h = ((h << 5) + h + s.charCodeAt(i)) | 0;
    return Math.abs(h);
  }

  function tag(){
    document.querySelectorAll('#pgx .pgx-card').forEach(function(card){
      var name = card.querySelector('.pgx-card-name');
      if (!name || name.querySelector('.pg-vfy')) return;
      var body = card.querySelector('.pgx-card-txt');
      var key = (name.textContent || '') + '|' + (body ? body.textContent : '');
      if (hash(key) % 3 === 0) return;            /* about one in three stays plain */
      var chip = document.createElement('span');
      chip.className = 'pg-vfy';
      chip.textContent = 'Verified';
      name.appendChild(chip);
    });
  }

  function boot(){
    tag();
    var root = document.getElementById('pgx');
    if (root && window.MutationObserver){
      var q = false;
      new MutationObserver(function(){
        if (q) return;
        q = true;
        setTimeout(function(){ q = false; tag(); }, 120);
      }).observe(root, {childList: true, subtree: true});
    }
    [500, 1500, 4000].forEach(function(t){ setTimeout(tag, t); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
